import cx from "classnames";
import Table from "components/Table/Table";
import { commonColumnProps, PAGE_SIZE } from "constants/TableConstants";
import { useState } from "react";
import type { FeedExportLogDataType } from "types/DataTypes";
import { useParams } from "react-router-dom";
import { setShowClientExportFeedsDrawer } from "reducers/drawer";
import { useGetClientExportFeedsByIdQuery } from "services/client-api";
import { useDispatch, useSelector } from "utils/redux";

const ClientExportFeedsDrawer = () => {
  const dispatch = useDispatch();
  const { clientId } = useParams<{ clientId: string }>();
  const [page, setPage] = useState(1);

  const showClientExportFeedsDrawer = useSelector(
    (state) => state.drawer.showClientExportFeedsDrawer,
  );

  const {
    data: feeds = { results: [], count: 0 },
    isFetching,
    isLoading,
  } = useGetClientExportFeedsByIdQuery(
    {
      clientId,
    },
    {
      skip: !clientId,
    },
  );
  const rows =
    (feeds as unknown as { results: FeedExportLogDataType[] })?.results?.map(
      (feed: FeedExportLogDataType) => ({
        id: feed.id,
        rre_name: feed.rre_name,
        status_verbose: feed.status_verbose,
        type_verbose: feed.type_verbose,
        export_start_time: feed.export_start_time,
        export_end_time: feed.export_end_time,
        response_item_description: feed.response_item_description,
      }),
    ) || [];

  // Show loading state when drawer is open but data hasn't loaded yet
  const isTableLoading =
    setShowClientExportFeedsDrawer && (isFetching || isLoading);

  const FEED_COLUMNS = [
    { key: "id", name: "ID", ...commonColumnProps },
    { key: "rre_name", name: "RRE", ...commonColumnProps },
    { key: "status_verbose", name: "Status", ...commonColumnProps },
    { key: "type_verbose", name: "Type", ...commonColumnProps },
    {
      key: "response_item_description",
      name: "Response Item",
      ...commonColumnProps,
    },
    { key: "export_start_time", name: "Started", ...commonColumnProps },
    { key: "export_end_time", name: "Completed", ...commonColumnProps },
  ];

  return (
    <div
      className={cx("documents documents-modal flex jc-se", {
        open: showClientExportFeedsDrawer,
      })}
    >
      <div className="documents-wrapper w-search">
        <div className="header-primary flex jc-sb">
          Client Import Feeds
          <a
            className="header-primary alt-btn"
            onClick={() => dispatch(setShowClientExportFeedsDrawer(false))}
          >
            Close
          </a>
        </div>

        <div className="data-values mrg-top">
          <Table
            columns={FEED_COLUMNS}
            rows={rows}
            rowKeyGetter={(row: FeedExportLogDataType) => row.id}
            onCellClick={() => {}}
            isLoading={isTableLoading}
            drawer={true}
            pagination={{
              pageSize: PAGE_SIZE,
              pageIndex: page,
              rowCount: (feeds as unknown as { count: number }).count,
              onPageChange: (pageIndex) => setPage(pageIndex),
              isLoading: isTableLoading,
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default ClientExportFeedsDrawer;
